// import React, { useState, useRef } from 'react';
// import { Link } from 'react-router-dom';

// const ClientFeedbacks = () => {
//   const [activeFeedbackId, setActiveFeedbackId] = useState(1);
//   const scrollerRef = useRef(null);

//   // Real-world Premium Client Feedback Dataset
//   const feedbackList = [
//     {
//       id: 1,
//       quote: "ST Studio didn't simply design our kitchen framework; they calculated our physical movement patterns. The natural light optimization completely transformed our everyday morning workflow experience.",
//       author: "Ananya Deshmukh",
//       project: "The Linen Kitchen Vault",
//       location: "Koregaon Park, Pune",
//       rating: "⭐⭐⭐⭐⭐",
//       gridSpan: "large"
//     },
//     {
//       id: 2,
//       quote: "Exceptional space planning. The custom travertine basin counter is an absolute masterpiece of material layering.",
//       author: "Rohan Malhotra",
//       project: "Travertine Wash Counter",
//       location: "Kalyani Nagar, Pune",
//       rating: "⭐⭐⭐⭐⭐",
//       gridSpan: "small"
//     },
//     {
//       id: 3,
//       quote: "The symmetry structural planning inside our master bedroom vault creates a profound subconscious state of stillness. Highly recommend their bespoke pastel design curations.",
//       author: "Dr. Kavita Sharma",
//       project: "Alabaster Bedroom Suite",
//       location: "Aundh, Pune",
//       rating: "⭐⭐⭐⭐⭐",
//       gridSpan: "small"
//     },
//     {
//       id: 4,
//       quote: "We are thoroughly impressed by how they hid complex storage utility parameters inside clean, minimalist geometric foyer panels. Dynamic, responsive, and highly professional draftsmen.",
//       author: "Vikram & Sneha Mehta",
//       project: "The Entrance Portal",
//       location: "Baner Hills, Pune",
//       rating: "⭐⭐⭐⭐⭐",
//       gridSpan: "large"
//     }
//   ];

//   const theme = {
//     background: '#F8F6F2',   // Soft Alabaster White
//     surface: '#FFFFFF',      // Pure White Base
//     accent: '#D4AF37',       // Champagne Gold Accent
//     textMain: '#2C302E',     // Charcoal Slate
//     textMuted: '#7A827E',    // Soft Muted Sage Grey
//     border: 'rgba(44, 48, 46, 0.08)'
//   };

//   // Tracks horizontal swipe on mobile to update active indicator dots
//   const handleMobileScroll = () => {
//     if (!scrollerRef.current || window.innerWidth > 768) return;
//     const scroller = scrollerRef.current;
//     const cardWidth = scroller.firstChild.offsetWidth + 20; 
//     const scrollPosition = scroller.scrollLeft + (scroller.offsetWidth / 2);
//     const index = Math.floor(scrollPosition / cardWidth);

//     if (feedbackList[index] && feedbackList[index].id !== activeFeedbackId) {
//       setActiveFeedbackId(feedbackList[index].id);
//     }
//   };

//   const inlineStyles = `
//     @keyframes cardEntrance {
//       from { opacity: 0; transform: translateY(30px); }
//       to { opacity: 1; transform: translateY(0); }
//     }
//     .animate-feedback-card { animation: cardEntrance 1s cubic-bezier(0.16, 1, 0.3, 1) forwards; }

//     /* ==================== MOBILE RESPONSIVE PLATFORM BREAKPOINTS ==================== */
//     @media (max-width: 768px) {
//       .feedback-screen-padding { padding: 30px 20px !important; }
//       .feedback-main-title { font-size: 2.2rem !important; }

//       /* Transforms grid view into an iPhone touch-swipe track loop */
//       .feedback-responsive-masonry {
//         display: flex !important;
//         flex-direction: row !important;
//         overflow-x: auto !important;
//         overflow-y: hidden !important;
//         scroll-snap-type: x mandatory !important;
//         gap: 20px !important;
//         padding: 10px 5px 25px 5px !important;
//         scrollbar-width: none;
//       }
//       .feedback-responsive-masonry::-webkit-scrollbar { display: none; }

//       .feedback-card-node {
//         min-width: 85vw !important;
//         height: 380px !important;
//         scroll-snap-align: center !important;
//         flex-shrink: 0 !important;
//         padding: 30px 20px !important;
//         box-shadow: 0 15px 30px rgba(44, 48, 46, 0.04) !important;
//       }
//       .grid-span-large-override { grid-column: auto !important; }
//       .mobile-indicator-dots-row { display: flex !important; }
//     }
//   `;

//   return (
//     <div className="feedback-screen-padding" style={{
//       background: theme.background,
//       minHeight: '100vh',
//       color: theme.textMain,
//       padding: '40px 60px',
//       fontFamily: 'system-ui, -apple-system, sans-serif',
//       boxSizing: 'border-box'
//     }}>
//       <style>{inlineStyles}</style>



//       {/* Screen Title */}
//       <div style={{ marginBottom: '50px' }}>
//         <span style={{ color: theme.accent, textTransform: 'uppercase', letterSpacing: '4px', fontSize: '0.85rem', fontWeight: '700' }}>Vouched Comfort</span>
//         <h1 className="feedback-main-title" style={{ fontSize: '3.2rem', fontWeight: '300', margin: '5px 0 0 0', letterSpacing: '1px' }}>Studio Journals</h1>
//       </div>

//       {/* ==================== ASYMMETRIC GRID MASONRY STAGE ==================== */}
//       <div 
//         className="feedback-responsive-masonry"
//         ref={scrollerRef}
//         onScroll={handleMobileScroll}
//         style={{
//           display: 'grid',
//           gridTemplateColumns: 'repeat(auto-fill, minmax(340px, 1fr))',
//           gap: '30px',
//           gridAutoFlow: 'dense'
//         }}
//       >
//         {feedbackList.map((card, idx) => {
//           const isLarge = card.gridSpan === 'large';

//           return (
//             <div
//               key={card.id}
//               className="animate-feedback-card grid-span-large-override"
//               style={{
//                 gridColumn: isLarge ? 'span 2' : 'auto',
//                 background: theme.surface,
//                 border: `1px solid ${theme.border}`,
//                 borderRadius: '24px',
//                 padding: '40px',
//                 boxSizing: 'border-box',
//                 display: 'flex',
//                 flexDirection: 'column',
//                 justifyContent: 'space-between',
//                 position: 'relative',
//                 transition: 'all 0.4s cubic-bezier(0.16, 1, 0.3, 1)',
//                 animationDelay: `${idx * 0.1}s`
//               }}
//               onMouseEnter={(e) => {
//                 if (window.innerWidth > 768) {
//                   e.currentTarget.style.transform = 'translateY(-6px)';
//                   e.currentTarget.style.boxShadow = '0 20px 40px rgba(44, 48, 46, 0.05)';
//                   e.currentTarget.style.borderColor = theme.accent;
//                 }
//               }}
//               onMouseLeave={(e) => {
//                 if (window.innerWidth > 768) {
//                   e.currentTarget.style.transform = 'translateY(0)';
//                   e.currentTarget.style.boxShadow = 'none';
//                   e.currentTarget.style.borderColor = theme.border;
//                 }
//               }}
//             >
//               {/* Card Upper Deck: Quote Icon & Rating */}
//               <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
//                 <span style={{ fontSize: '3.5rem', color: theme.accent, lineHeight: '0', fontFamily: 'serif', marginTop: '25px', opacity: 0.7 }}>“</span>
//                 <span style={{ fontSize: '0.85rem', letterSpacing: '2px' }}>{card.rating}</span>
//               </div>

//               {/* Central Paragraph Body */}
//               <p style={{
//                 fontSize: isLarge ? '1.2rem' : '1.05rem',
//                 lineHeight: '1.7',
//                 fontWeight: '300',
//                 margin: '0 0 30px 0',
//                 color: theme.textMain,
//                 fontStyle: 'italic'
//               }}>
//                 {card.quote}
//               </p>

//               {/* Lower Profile Signature Metadata */}
//               <div style={{ borderTop: `1px solid ${theme.border}`, paddingTop: '20px' }}>
//                 <h4 style={{ margin: '0 0 4px 0', fontSize: '1.1rem', fontWeight: '600', color: theme.textMain }}>{card.author}</h4>
//                 <div style={{ display: 'flex', flexWrap: 'wrap', gap: '5px 10px', fontSize: '0.85rem', color: theme.textMuted }}>
//                   <span style={{ color: theme.accent, fontWeight: '500' }}>{card.project}</span>
//                   <span>•</span>
//                   <span>{card.location}</span>
//                 </div>
//               </div>
//             </div>
//           );
//         })}
//       </div>

//       {/* ==================== MOBILE NAVIGATION DOT INDICATORS ==================== */}
//       <div 
//         className="mobile-indicator-dots-row" 
//         style={{
//           display: 'none',
//           justifyContent: 'center',
//           gap: '8px',
//           marginTop: '20px'
//         }}
//       >
//         {feedbackList.map((dot) => (
//           <div 
//             key={dot.id}
//             style={{
//               width: activeFeedbackId === dot.id ? '24px' : '8px',
//               height: '8px',
//               borderRadius: '4px',
//               background: activeFeedbackId === dot.id ? theme.accent : 'rgba(44, 48, 46, 0.2)',
//               transition: 'all 0.3s ease'
//             }}
//           />
//         ))}
//       </div>
//     </div>
//   );
// };

// export default ClientFeedbacks;





// import React, { useState, useRef } from 'react';
// import { Link } from 'react-router-dom';

// import clientReviewVideo from '../Assets/slider/client2video.mp4';
// import clientReviewPhoto from '../Assets/slider/clint1.jpg';
// import clientReviewPhoto3 from '../Assets/slider/client3.jpg';
// import clientReviewvideo4 from '../Assets/slider/client4video.mp4';


// import { type } from '@testing-library/user-event/dist/type';

// const ClientFeedbacks = () => {
//     const [activeFeedbackId, setActiveFeedbackId] = useState(1);
//     const [fullscreenVideo, setFullscreenVideo] = useState(null);
//     const [hoveredVideoId, setHoveredVideoId] = useState(null);
//     const [hoveredPhotoId, setHoveredPhotoId] = useState(null);

//     const scrollerRef = useRef(null);
//     const videoRefs = useRef({});

//     // 2. MIXED DATASET: Video Review + Text Testimonials + Real Photo Review Slot
//     const feedbackList = [
//         {
//             id: 1,
//             type: 'video',
//             src: clientReviewVideo,
//             author: "Sanket & Gauri Raut",
//             project: "Songbirds Society",
//             location: "Bhugaon, Pune",
//             gridSpan: "large"
//         },
//         {
//             id: 2,
//             type: 'photo', // Photo Identifier Flag
//             src: clientReviewPhoto,
//             quote: "Designing our living room with ST Studio was an absolute pleasure. Their pastel color management completely breathed new life into our home space.",
//             author: "KALPESH HIWASE",
//             project: "The Sage Apartment",
//             location: "Kalyani Nagar, Pune",
//             gridSpan: "small"
//         },
//         {
//             id: 3,
//             type: 'photo',
//             src: clientReviewPhoto3,
//             quote: "A linear, space-optimized office layout featuring dual rows of ergonomic workstations. Curved wooden planter partitions frame the entrance, while integrated linear lights and a minimal world map graphic create a highly professional aesthetic.",
//             author: "Gaurav Joshi",
//             project: "Platinum 9",
//             location: "Pashan-sus, Pune",
//             rating: "⭐⭐⭐⭐⭐",
//             gridSpan: "small"
//         },
//         {
//             id: 4,
//             type: 'video',
//             src: clientReviewvideo4,
//             quote: "We are thoroughly impressed by how they hid complex storage utility parameters inside clean, minimalist geometric foyer panels. Dynamic, responsive, and highly professional draftsmen.",
//             author: "KEDAR BENDRE",
//             project: "The Entrance Portal",
//             location: "Baner Hills, Pune",
//             rating: "⭐⭐⭐⭐⭐",
//             gridSpan: "large"
//         }
//     ];

//     const theme = {
//         background: '#F8F6F2',
//         surface: '#FFFFFF',
//         accent: '#D4AF37',
//         textMain: '#2C302E',
//         textMuted: '#7A827E',
//         border: 'rgba(44, 48, 46, 0.08)'
//     };

//     const handleMobileScroll = () => {
//         if (!scrollerRef.current || window.innerWidth > 768) return;
//         const scroller = scrollerRef.current;
//         const cardWidth = scroller.firstChild.offsetWidth + 20;
//         const scrollPosition = scroller.scrollLeft + (scroller.offsetWidth / 2);
//         const index = Math.floor(scrollPosition / cardWidth);

//         if (feedbackList[index] && feedbackList[index].id !== activeFeedbackId) {
//             setActiveFeedbackId(feedbackList[index].id);
//         }
//     };

//     const handleVideoPlay = (id) => {
//         setHoveredVideoId(id);
//         if (videoRefs.current[id]) {
//             videoRefs.current[id].play().catch(() => { });
//         }
//     };

//     const handleVideoPause = (id) => {
//         setHoveredVideoId(null);
//         if (videoRefs.current[id]) {
//             videoRefs.current[id].pause();
//             videoRefs.current[id].currentTime = 0;
//         }
//     };

//     const inlineStyles = `
//     @keyframes cardEntrance {
//       from { opacity: 0; transform: translateY(30px); }
//       to { opacity: 1; transform: translateY(0); }
//     }
//     .animate-feedback-card { animation: cardEntrance 1s cubic-bezier(0.16, 1, 0.3, 1) forwards; }

//     @media (max-width: 768px) {
//       .feedback-screen-padding { padding: 30px 20px !important; }
//       .feedback-main-title { font-size: 2.2rem !important; }

//       .feedback-responsive-masonry {
//         display: flex !important;
//         flex-direction: row !important;
//         overflow-x: auto !important;
//         overflow-y: hidden !important;
//         scroll-snap-type: x mandatory !important;
//         gap: 20px !important;
//         padding: 10px 5px 25px 5px !important;
//         scrollbar-width: none;
//       }
//       .feedback-responsive-masonry::-webkit-scrollbar { display: none; }

//       .feedback-card-node {
//         min-width: 85vw !important;
//         height: 420px !important;
//         scroll-snap-align: center !important;
//         flex-shrink: 0 !important;
//         padding: 30px 20px !important;
//       }
//       .grid-span-large-override { grid-column: span 1 !important; }
//       .mobile-indicator-dots-row { display: flex !important; }
//     }
//   `;

//     return (
//         <div className="feedback-screen-padding" style={{
//             background: theme.background,
//             minHeight: '100vh',
//             color: theme.textMain,
//             padding: '40px 60px',
//             fontFamily: 'system-ui, -apple-system, sans-serif',
//             boxSizing: 'border-box'
//         }}>
//             <style>{inlineStyles}</style>


//             {/* Screen Title */}
//             <div style={{ marginBottom: '50px' }}>
//                 <span style={{ color: theme.accent, textTransform: 'uppercase', letterSpacing: '4px', fontSize: '0.85rem', fontWeight: '700' }}>Vouched Comfort</span>
//                 <h1 className="feedback-main-title" style={{ fontSize: '3.2rem', fontWeight: '300', margin: '5px 0 0 0', letterSpacing: '1px' }}>Studio Journals</h1>
//             </div>

//             {/* ==================== ASYMMETRIC GRID MASONRY STAGE ==================== */}
//             <div
//                 className="feedback-responsive-masonry"
//                 ref={scrollerRef}
//                 onScroll={handleMobileScroll}
//                 style={{
//                     display: 'grid',
//                     gridTemplateColumns: 'repeat(auto-fill, minmax(340px, 1fr))',
//                     gap: '30px',
//                     gridAutoFlow: 'dense'
//                 }}
//             >
//                 {feedbackList.map((card, idx) => {
//                     const isLarge = card.gridSpan === 'large';
//                     const isVideo = card.type === 'video';
//                     const isPhoto = card.type === 'photo';

//                     return (
//                         <div
//                             key={card.id}
//                             className="animate-feedback-card grid-span-large-override feedback-card-node"
//                             onMouseEnter={() => {
//                                 if (isVideo) handleVideoPlay(card.id);
//                                 if (isPhoto) setHoveredPhotoId(card.id);
//                             }}
//                             onMouseLeave={() => {
//                                 if (isVideo) handleVideoPause(card.id);
//                                 if (isPhoto) setHoveredPhotoId(null);
//                             }}
//                             onClick={() => isVideo && setFullscreenVideo(card.src)}
//                             style={{
//                                 gridColumn: isLarge ? 'span 2' : 'auto',
//                                 background: (isVideo || isPhoto) ? '#1A1C1B' : theme.surface,
//                                 border: `1px solid ${theme.border}`,
//                                 borderRadius: '24px',
//                                 padding: '30px',
//                                 boxSizing: 'border-box',
//                                 display: 'flex',
//                                 flexDirection: 'column',

//                                 // 1. THIS PUSHES CONTENT TO THE BOTTOM
//                                 justifyContent: 'flex-end',

//                                 position: 'relative',
//                                 overflow: 'hidden',
//                                 cursor: isVideo ? 'pointer' : 'default',
//                                 transition: 'all 0.4s cubic-bezier(0.16, 1, 0.3, 1)',
//                                 animationDelay: `${idx * 0.1}s`,

//                                 // 2. THIS MAKES HEIGHT UNIFORM
//                                 height: '400px'
//                             }}

//                         >
//                             {/* IF CASE 1: VIDEO CARD TYPE */}
//                             {isVideo && (
//                                 <>
//                                     <video
//                                         ref={(el) => (videoRefs.current[card.id] = el)}
//                                         loop
//                                         muted
//                                         playsInline
//                                         style={{
//                                             position: 'absolute',
//                                             top: 0,
//                                             left: 0,
//                                             width: '100%',
//                                             height: '100%',
//                                             objectFit: 'cover',
//                                             opacity: hoveredVideoId === card.id ? 0.8 : 0.45,
//                                             transition: 'opacity 0.4s ease'
//                                         }}
//                                     >
//                                         <source src={card.src} type="video/mp4" />
//                                     </video>
//                                     {/* <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', background: 'linear-gradient(to top, rgba(0,0,0,0.8) 0%, transparent 100%)', zIndex: 2 }} /> */}
//                                     <div style={{
//                                         position: 'absolute',
//                                         top: 0,
//                                         left: 0,
//                                         width: '100%',
//                                         height: '100%',
//                                         // This creates a solid dark background at the bottom that blends out into transparency at the top
//                                         background: 'linear-gradient(to top, rgba(0,0,0,0.95) 0%, rgba(0,0,0,0.4) 65%, transparent 100%)',
//                                         zIndex: 2,
//                                         pointerEvents: 'none'
//                                     }} />
//                                     <div style={{ position: 'absolute', top: '30px', right: '30px', zIndex: 3, background: theme.surface, color: theme.textMain, padding: '6px 14px', borderRadius: '30px', fontSize: '0.75rem', fontWeight: '700', letterSpacing: '1px' }}>
//                                         VIDEO REVIEW
//                                     </div>
//                                     <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: '50px', height: '50px', borderRadius: '50%', background: 'rgba(255, 255, 255, 0.2)', border: '1px solid rgba(255, 255, 255, 0.4)', backdropFilter: 'blur(8px)', display: 'flex', justifyContent: 'center', alignItems: 'center', color: '#FFF', zIndex: 3, opacity: hoveredVideoId === card.id ? 0 : 1, transition: 'opacity 0.3s ease' }}>▶</div>
//                                     <div style={{ zIndex: 3, borderTop: '1px solid rgba(255,255,255,0.1)', paddingTop: '20px', width: '100%', marginTop: 'auto' }}>
//                                         <h4 style={{ margin: '0 0 4px 0', fontSize: '1.1rem', fontWeight: '600', color: '#FFF' }}>{card.author}</h4>
//                                         <div style={{ display: 'flex', gap: '10px', fontSize: '0.85rem', color: '#E5E7EB' }}>
//                                             <span style={{ color: theme.accent, fontWeight: '500' }}>{card.project}</span>
//                                             <span>•</span>
//                                             <span>{card.location}</span>
//                                         </div>
//                                     </div>
//                                 </>
//                             )}

//                             {/* IF CASE 2: PHOTO CARD TYPE */}
//                             {isPhoto && (
//                                 <>
//                                     <img
//                                         src={card.src}
//                                         alt="Client Space Creation"
//                                         style={{
//                                             position: 'absolute',
//                                             top: 0,
//                                             left: 0,
//                                             width: '100%',
//                                             height: '100%',
//                                             objectFit: 'cover',
//                                             opacity: hoveredPhotoId === card.id ? 0.4 : 0.25,
//                                             transform: hoveredPhotoId === card.id ? 'scale(1.05)' : 'scale(1)',
//                                             transition: 'all 0.6s cubic-bezier(0.16, 1, 0.3, 1)'
//                                         }}
//                                     />
//                                     {/* <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', background: 'linear-gradient(to top, rgba(0,0,0,0.85) 0%, rgba(0,0,0,0.3) 100%)', zIndex: 2 }} /> */}
//                                     <div style={{
//                                         position: 'absolute',
//                                         top: 0,
//                                         left: 0,
//                                         width: '100%',
//                                         height: '100%',
//                                         // This creates a solid dark background at the bottom that blends out into transparency at the top
//                                         background: 'linear-gradient(to top, rgba(0,0,0,0.95) 0%, rgba(0,0,0,0.4) 65%, transparent 100%)',
//                                         zIndex: 2,
//                                         pointerEvents: 'none'
//                                     }} />

//                                     <div style={{ position: 'absolute', top: '30px', right: '30px', zIndex: 3, background: 'rgba(255,255,255,0.15)', backdropFilter: 'blur(6px)', color: '#FFF', padding: '6px 14px', borderRadius: '30px', fontSize: '0.75rem', fontWeight: '600', letterSpacing: '1px' }}>
//                                         PROJECT SNAP
//                                     </div>

//                                     {/* Wrap your quotes, author names, and project location fields inside this structure */}
//                                     <div style={{ zIndex: 3, width: '100%' }}>
//                                         <p style={{ fontSize: '0.95rem', lineHeight: '1.5', fontWeight: '300', color: '#E5E7EB', fontStyle: 'italic', margin: '0 0 15px 0' }}>
//                                             "{card.quote}"
//                                         </p>
//                                         <h4 style={{ margin: '0 0 4px 0', fontSize: '1.1rem', fontWeight: '600', color: '#FFFFFF' }}>
//                                             {card.author}
//                                         </h4>
//                                         <div style={{ display: 'flex', gap: '10px', fontSize: '0.8rem', color: '#D1D5DB' }}>
//                                             <span style={{ color: theme.accent, fontWeight: '500' }}>{card.project}</span>
//                                             <span>•</span>
//                                             <span>{card.location}</span>
//                                         </div>
//                                     </div>


//                                 </>
//                             )}

//                             {/* IF CASE 3: STANDARD TEXT CARD TYPE */}
//                             {!isVideo && !isPhoto && (
//                                 <>
//                                     <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
//                                         <span style={{ fontSize: '3.5rem', color: theme.accent, lineHeight: '0', fontFamily: 'serif', marginTop: '25px', opacity: 0.7 }}>“</span>
//                                         <span style={{ fontSize: '0.85rem', letterSpacing: '2px' }}>{card.rating}</span>
//                                     </div>

//                                     <p style={{ fontSize: isLarge ? '1.2rem' : '1.05rem', lineHeight: '1.7', fontWeight: '300', margin: '0 0 30px 0', color: theme.textMain, fontStyle: 'italic' }}>
//                                         {card.quote}
//                                     </p>

//                                     <div style={{ borderTop: `1px solid ${theme.border}`, paddingTop: '20px' }}>
//                                         <h4 style={{ margin: '0 0 4px 0', fontSize: '1.1rem', fontWeight: '600', color: theme.textMain }}>{card.author}</h4>
//                                         {/* AFTER THE FIX: */}
//                                         <div style={{ display: 'flex', flexWrap: 'wrap', gap: '5px 10px', fontSize: '0.85rem', color: theme.textMuted }}>
//                                             {/* Clean mapping to card.project fixes the no-undef breakdown */}
//                                             <span style={{ color: theme.accent, fontWeight: '500' }}>{card.project}</span>
//                                             <span>•</span>
//                                             <span>{card.location}</span>
//                                         </div>

//                                     </div>
//                                 </>
//                             )}
//                         </div>
//                     );
//                 })}
//             </div>

//             {/* ==================== MOBILE NAVIGATION DOT INDICATORS ==================== */}
//             <div className="mobile-indicator-dots-row" style={{ display: 'none', justifyContent: 'center', gap: '8px', marginTop: '20px' }}>
//                 {feedbackList.map((dot) => (
//                     <div
//                         key={dot.id}
//                         style={{
//                             width: activeFeedbackId === dot.id ? '24px' : '8px',
//                             height: '8px',
//                             borderRadius: '4px',
//                             background: activeFeedbackId === dot.id ? theme.accent : 'rgba(44, 48, 46, 0.2)',
//                             transition: 'all 0.3s ease'
//                         }}
//                     />
//                 ))}
//             </div>

//             {/* ==================== THEATER FULLSCREEN VIDEO LIGHTBOX OVERLAY ==================== */}
//             {fullscreenVideo && (
//                 <div
//                     onClick={() => setFullscreenVideo(null)}
//                     style={{
//                         position: 'fixed',
//                         top: 0,
//                         left: 0,
//                         width: '100vw',
//                         height: '100vh',
//                         background: 'rgba(15, 17, 21, 0.98)',
//                         zIndex: 200,
//                         display: 'flex',
//                         justifyContent: 'center',
//                         alignItems: 'center',
//                         backdropFilter: 'blur(15px)'
//                     }}
//                 >
//                     <button
//                         onClick={() => setFullscreenVideo(null)}
//                         style={{ position: 'absolute', top: '30px', right: '40px', background: 'none', border: 'none', color: '#FFF', fontSize: '2.5rem', cursor: 'pointer', opacity: 0.8 }}
//                     >
//                         ✕
//                     </button>
//                     <video
//                         autoPlay
//                         controls
//                         playsInline
//                         onClick={(e) => e.stopPropagation()}
//                         style={{ width: '90vw', maxHeight: '85vh', borderRadius: '16px', boxShadow: '0 30px 70px rgba(0,0,0,0.8)', background: '#000' }}
//                     >
//                         <source src={fullscreenVideo} type="video/mp4" />
//                     </video>
//                 </div>
//             )}
//         </div>
//     );
// };

// export default ClientFeedbacks;

// import React, { useState, useRef } from 'react';

// import clientReviewVideo from '../Assets/slider/client2video.mp4';
// import clientReviewPhoto from '../Assets/slider/clint1half.jpg';
// import clientReviewPhoto3 from '../Assets/slider/client3.jpg';
// import clientReviewvideo4 from '../Assets/slider/client4video.mp4';

// const ClientFeedbacks = () => {
//     const [activeFeedbackId, setActiveFeedbackId] = useState(1);
//     const [fullscreenVideo, setFullscreenVideo] = useState(null);
//     const [hoveredVideoId, setHoveredVideoId] = useState(null);

//     const scrollerRef = useRef(null);
//     const videoRefs = useRef({});

//     const feedbackList = [
//         {
//             id: 1,
//             type: 'video',
//             src: clientReviewVideo,
//             quote: `We had a wonderful experience working with the Stinterior Studio. From the very first discussion to the final execution, they were extremely supportive, professional, and attentive to our needs. They took the time to understand our preferences, lifestyle, and budget, and translated them into a design that was both beautiful and practical. What really stood out was their attention to detail, transparent communication, and ability to solve challenges quickly during execution. The entire journey — from planning, design iterations, material selection, to on-site coordination — was smooth and well managed. \nThanks to their dedication and craftsmanship, our space has turned out exactly the way we envisioned (and even better). We truly appreciate their hard work and would highly recommend them to anyone looking for a reliable and creative interior design partner.`,
//             author: "Sanket & Gauri Raut",
//             project: "Songbirds Society",
//             location: "Bhugaon, Pune"
//         },
//         {
//             id: 2,
//             type: 'photo',
//             src: clientReviewPhoto,
//             quote: `STInterior Studio was recommended to us by a close friend, and from our very first meeting, we knew we had made the right choice.\n
// They brought fresh ideas and thoughtful solutions that perfectly matched our vision often suggesting better alternatives we hadn't even considered. Every discussion was handled with patience, professionalism, and genuine attention to detail, making the entire journey smooth and enjoyable.\n
// We're truly delighted with the outcome and would happily recommend STInterior Studio to anyone looking for beautifully designed, thoughtfully crafted interiors.`,
//             author: "Kalpesh Hiwase",
//             project: "The Sage Apartment",
//             location: "Kalyani Nagar, Pune"
//         },
//         {
//             id: 5,
//             type: 'text',
//             quote: `We explored every possible options for interior designer, and the online/offline reviews confused us even more. We accidentally bumped into stinterior studio through a distant contact. I had a few calls with Ar.Shreya and met her in-person .We took a leap of faith and signed up with Stinterior Studio .We had an amazing experience overall, some of the aspects that stood out are: 
// -Innovative and meticulous design.
// -Great attention to detail  Initial estimates where very much in line with the final expense 
// -Transparency through the phases - expense & payments, progress reporting.
// -End to end ownership during the execution phase by dealing with vendors and tracking the progress. 
// They are a true professional and highly gifted designer. They have a unique ability to really listen and genuinely takes the time to understand you and your project. They are courteous, reliable and a real pleasure to work with. They are exceptionally accommodating with requests and are generous and intuitive always creating a feeling of complete ease and trust. Thank you both for a memorable experience and being part of this journey to build our office. Absolutely loved it. We recommend her highly. Go ahead with them without any second thought.`,
//             author: "Meera & Rohan Deshmukh",
//             project: "The Monolith Villa",
//             location: "Aundh, Pune",
//             rating: "⭐⭐⭐⭐⭐",
//             gridSpan: "small"
//         },
//         {
//             id: 3,
//             type: 'photo',
//             quote: `I had a wonderful experience working with Ar.Shreya (Stinterior Studio), right from the very first conversation I was very much impressed by the first conversation. She clearly explained the entire process and took the time to truly understand my vision—creating a my office that feels comfortable and elegant without being too gaudy. \n
// Their creativity in design, excellent coordination, and ability to manage the entire project within the promised timelines really stood out. The team went above and beyond in helping me with selections,which made a huge difference in bringing everything together beautifully. I’m extremely happy with the outcome and would definitely recommend this team for their teamwork, creativity, thoughtful design approach.`,
//             src: clientReviewPhoto3,
//             author: "Gaurav Joshi",
//             project: "Platinum 9",
//             location: "Pashan-sus, Pune"
//         },

//         {
//             id: 4,
//             type: 'video',
//             src: clientReviewvideo4,
//             quote: `I got in touch with Ar.Shreya from Stinterior Studio to design our first home. Right on the first call,Ar.Shreya provided a lot of clarity on her work process and style. \n
// She was able to understand our vision and managed to translate it beautifully. She is extremely patient, polite, a good listener and always puts her client's needs first. She is a perfectionist and a go getter and won't compromise on the quality of work. She also keeps a close watch on the budget and always presented us a with a variety of options for all our selections. She works with a lot of integrity, is very approachable and hands on. It was a great experience working with her and the team and I would highly recommend her!`,
//             author: "Kedar Bendre",
//             project: "The Entrance Portal",
//             location: "Baner Hills, Pune"
//         },

//         {
//             id: 6,
//             type: 'text',
//             author: "Ananya Roy",
//             quote: `AR.Shreya (Stinterior studio)is very professional and she has got great taste in implementation and design. She is extremely prompt and supportive. She delivered what we actually imagined for our house. You can blindly trust her in her choices. Highly recommended.`,
//             project: "Aether Penthouse",
//             location: "Koregaon Park, Pune",
//             rating: "⭐⭐⭐⭐⭐",
//             gridSpan: "small"
//         },
//         {
//             id: 7,
//             type: 'text',
//             author: "Ananya Roy",
//             quote: `Some people look for beautiful place, some make a place beautiful.\n\nWe are extremely happy with the work done by Ar. Shreya. What impressed us the most was her excellent communication. She patiently listened to our ideas and never forced her choices on us. Instead, she explained every option clearly and calmly, helping us make the right decisions.\n\nShe has a wonderful sense of color and used elegant, decent shades that give our home a warm and sophisticated look. Every corner of the house has been utilized thoughtfully and efficiently, making the space both beautiful and functional. The combination of wallpapers and wall colors is simply perfect and has enhanced the overall look of our home.\n\nHer professionalism, creativity, patience, and attention to detail made the entire journey smooth and enjoyable. We truly appreciate her dedication and highly recommend her to anyone looking for a talented and trustworthy interior designer.\n\nThank you for turning our dream home into a beautiful reality!`,
//             project: "Aether Penthouse",
//             location: "Koregaon Park, Pune",
//             rating: "⭐⭐⭐⭐⭐",
//             gridSpan: "small"
//         },
//         {
//             id: 8,
//             type: 'text',
//             author: "Ananya Roy",
//             quote: `When we were looking for an Interior Designer for our newly purchased property, we had a very specific idea of what our home should "feel" like, so our search zeroed in on a select few in the Baner area. The process of finally choosing one came down to cost, timelines, and whether we felt the designer truly understood our taste and needs. With some designers, the very first meeting ended without any meaningful discussion, while others quoted unrealistically low prices just to win the project, which itself felt like a warning sign. It made us wonder whether any designer would genuinely take the time to understand our vision.

// Then we came to know about Stinterior Studio. When I called Ar. Shreya and requested a meeting, my worries started to disappear. Here was a designer who visited our apartment for the very first time and immediately shared several thoughtful ideas while also taking the time to understand our taste and our family's requirements. Unlike others, who wouldn't even discuss concepts before receiving the first payment, Stinterior Studio was a refreshing and welcome find.

// Needless to say, we decided to go ahead with Stinterior Studio for designing our home.

// Today, we absolutely love our dream home and continue to receive compliments from everyone who visits.

// Thanks to Ar. Shreya and her team! We highly recommend Stinterior Studio!`,
//             project: "Aether Penthouse",
//             location: "Koregaon Park, Pune",
//             rating: "⭐⭐⭐⭐⭐",
//             gridSpan: "small"
//         },
//         {
//             id: 9,
//             type: 'text',
//             author: "Ananya Roy",
//             quote: `Easy, fun, and spot-on design service!

// When you meet someone as passionate as Ar. Shreya and her team, you immediately know that their heart is truly in their work.

// We did extensive research before choosing an interior designer because we wanted someone who was understanding, collaborative, honest, flexible, and creative. We finally chose Stinterior Studio, and it turned out to be the perfect decision. They did an excellent job transforming the vision we had for our space into a beautiful reality.

// We especially loved their process of understanding our requirements before proposing solutions. Their flexibility, responsiveness, involvement, agility, and exceptional talent and sense of design made the entire journey smooth and stress-free.

// We are truly delighted with the outcome and highly recommend Ar. Shreya and the Stinterior Studio team to anyone looking for a professional and creative interior design partner.`,
//             project: "Aether Penthouse",
//             location: "Koregaon Park, Pune",
//             rating: "⭐⭐⭐⭐⭐",
//             gridSpan: "small"
//         }, {
//             id: 10,
//             type: 'text',
//             author: "Ananya Roy",
//             quote: `We are one of the happy customers who chose Stinterior Studio to design our home. Ar. Shreya and her team helped us turn our dream home into reality with the utmost perfection.

// From the very beginning until the completion of the project, their professionalism and proactive approach were truly commendable. Ar. Shreya's excellent consultative skills helped us make the right decisions at every stage of the journey.

// She paid attention to even the smallest details and ensured that every aspect of the design matched our expectations. Her creative approach, combined with a wide variety of design ideas and thoughtful suggestions, gave us the confidence that our home was in the right hands.

// Thank you, Ar. Shreya and the Stinterior Studio team, for making our dream home a beautiful reality. We highly recommend Stinterior Studio to anyone looking for a professional, creative, and reliable interior design partner.`,
//             project: "Aether Penthouse",
//             location: "Koregaon Park, Pune",
//             rating: "⭐⭐⭐⭐⭐",
//             gridSpan: "small"
//         },
//     ];

//     const theme = {
//         background: '#FDFCFB', // Premium warm white
//         surface: '#FFFFFF',    // Card base
//         accent: '#D4AF37',     // Luxury gold
//         textMain: '#2C302E',   // Deep charcoal
//         textMuted: '#7A827E',  // Muted gray
//         border: 'rgba(44, 48, 46, 0.08)'
//     };

//     const handleMobileScroll = () => {
//         if (!scrollerRef.current || window.innerWidth > 768) return;
//         const scroller = scrollerRef.current;
//         const cardWidth = scroller.firstChild.offsetWidth + 24;
//         const scrollPosition = scroller.scrollLeft + (scroller.offsetWidth / 2);
//         const index = Math.floor(scrollPosition / cardWidth);

//         if (feedbackList[index] && feedbackList[index].id !== activeFeedbackId) {
//             setActiveFeedbackId(feedbackList[index].id);
//         }
//     };

//     const handleVideoPlay = (id) => {
//         setHoveredVideoId(id);
//         if (videoRefs.current[id]) {
//             videoRefs.current[id].play().catch(() => { });
//         }
//     };

//     const handleVideoPause = (id) => {
//         setHoveredVideoId(null);
//         if (videoRefs.current[id]) {
//             videoRefs.current[id].pause();
//             videoRefs.current[id].currentTime = 0;
//         }
//     };

//     const inlineStyles = `
//     @import url('https://fonts.googleapis.com/css2?family=Cinzel:wght@400;500;600&display=swap');

//     @keyframes revealUp {
//         from { opacity: 0; transform: translateY(40px); }
//         to { opacity: 1; transform: translateY(0); }
//     }

//     .team-animate-entry { 
//         animation: revealUp 1.2s cubic-bezier(0.16, 1, 0.3, 1) forwards; 
//     }

//     /* Standard Project Card Style & Hover Zoom */
//     .project-feedback-card {
//         transition: transform 0.6s cubic-bezier(0.16, 1, 0.3, 1), 
//                     box-shadow 0.6s cubic-bezier(0.16, 1, 0.3, 1), 
//                     border-color 0.4s ease;
//         background: #FFFFFF;
//         border: 1px solid rgba(44, 48, 46, 0.08);
//         border-radius: 16px;
//         overflow: hidden;
//         display: flex;
//         flex-direction: column;
//         height: 100%;
//     }

//     .project-feedback-card:hover {
//         transform: translateY(-8px);
//         box-shadow: 0 20px 40px rgba(44, 48, 46, 0.06);
//         border-color: #D4AF37 !important;
//     }

//     .card-media-wrapper {
//         position: relative;
//         width: 100%;
//         height: 260px;
//         overflow: hidden;
//         background: #F3F4F6;
//     }

//     .project-card-media {
//         width: 100%;
//         height: 100%;
//         object-fit: cover;
//         transition: transform 0.8s cubic-bezier(0.16, 1, 0.3, 1);
//     }

//     .project-feedback-card:hover .project-card-media {
//         transform: scale(1.04);
//     }

//     .reel-indicator {
//         position: absolute;
//         bottom: 16px;
//         right: 16px;
//         background: rgba(255, 255, 255, 0.9);
//         color: #2C302E;
//         padding: 6px 12px;
//         border-radius: 20px;
//         font-size: 0.7rem;
//         font-weight: 700;
//         letter-spacing: 1px;
//         z-index: 5;
//         box-shadow: 0 4px 10px rgba(0,0,0,0.05);
//     }

//     @media (max-width: 768px) {
//         .feedback-screen-padding { padding: 40px 20px !important; }
//         .feedback-main-title { font-size: 2.2rem !important; letter-spacing: 4px !important; }

//         .feedback-row-layout {
//             display: flex !important;
//             flex-direction: row !important;
//             overflow-x: auto !important;
//             overflow-y: hidden !important;
//             scroll-snap-type: x mandatory !important;
//             gap: 24px !important;
//             padding: 10px 5px 25px 5px !important;
//             scrollbar-width: none;
//         }
//         .feedback-row-layout::-webkit-scrollbar { display: none; }

//         .project-feedback-card {
//             min-width: 85vw !important;
//             scroll-snap-align: center !important;
//             flex-shrink: 0 !important;
//         }
//         .mobile-indicator-dots-row { display: flex !important; }
//     }
//   `;

//     return (
//         <div className="feedback-screen-padding" style={{
//             background: theme.background,
//             minHeight: '100vh',
//             color: theme.textMain,
//             padding: '80px 60px',
//             fontFamily: 'system-ui, -apple-system, sans-serif',
//             boxSizing: 'border-box'
//         }}>
//             <style>{inlineStyles}</style>

//             {/* Premium Synchronized Header */}
//             <section className="team-animate-entry" style={{
//                 textAlign: 'center',
//                 marginBottom: '60px',
//                 padding: '0 20px'
//             }}>
//                 <span style={{
//                     fontFamily: 'system-ui, -apple-system, sans-serif',
//                     fontSize: '0.85rem',
//                     fontWeight: '600',
//                     textTransform: 'uppercase',
//                     letterSpacing: '4px',
//                     color: theme.accent,
//                     display: 'block',
//                     marginBottom: '12px'
//                 }}>
//                     Testimonials
//                 </span>
//                 <h1 className="feedback-main-title" style={{
//                     fontFamily: "'Cinzel', serif",
//                     fontSize: 'calc(2rem + 1.5vw)',
//                     fontWeight: '400',
//                     textTransform: 'uppercase',
//                     letterSpacing: '6px',
//                     color: theme.textMain,
//                     margin: 0
//                 }}>
//                     Client Journals
//                 </h1>
//                 <div style={{
//                     width: '60px',
//                     height: '1px',
//                     background: theme.accent,
//                     margin: '24px auto 0 auto'
//                 }} />
//             </section>

//             {/* ==================== PROJECT CARD ROW GRID ==================== */}
//             <div
//                 className="feedback-row-layout"
//                 ref={scrollerRef}
//                 onScroll={handleMobileScroll}
//                 style={{
//                     display: 'grid',
//                     gridTemplateColumns: 'repeat(auto-fill, minmax(340px, 1fr))',
//                     gap: '30px'
//                 }}
//             >
//                 {feedbackList.map((card, idx) => {
//                     const isVideo = card.type === 'video';

//                     return (
//                         <div
//                             key={card.id}
//                             className="team-animate-entry project-feedback-card"
//                             onMouseEnter={() => isVideo && handleVideoPlay(card.id)}
//                             onMouseLeave={() => isVideo && handleVideoPause(card.id)}
//                             onClick={() => isVideo && setFullscreenVideo(card.src)}
//                             style={{
//                                 animationDelay: `${idx * 0.15}s`
//                             }}
//                         >
//                             {/* Card Media Top Portion: 100% Crisp, No Color Wash */}
//                             <div className="card-media-wrapper">
//                                 {isVideo ? (
//                                     <>
//                                         <video
//                                             ref={(el) => (videoRefs.current[card.id] = el)}
//                                             className="project-card-media"
//                                             loop
//                                             muted
//                                             playsInline
//                                         >
//                                             <source src={card.src} type="video/mp4" />
//                                         </video>
//                                         <div className="reel-indicator">PLAY REEL</div>
//                                     </>
//                                 ) : (
//                                     <img
//                                         src={card.src}
//                                         alt={card.project}
//                                         className="project-card-media"
//                                     />
//                                 )}
//                             </div>

//                             {/* Card Content Bottom Portion: High-end project text block */}
//                             <div style={{
//                                 padding: '30px',
//                                 display: 'flex',
//                                 flexDirection: 'column',
//                                 justifyContent: 'space-between',
//                                 flexGrow: 1,
//                                 background: theme.surface
//                             }}>
//                                 <p style={{
//                                     fontSize: '0.95rem',
//                                     lineHeight: '1.6',
//                                     fontWeight: '400',
//                                     color: theme.textMain,
//                                     fontStyle: 'italic',
//                                     margin: '0 0 24px 0',
//                                     whiteSpace: "pre-line"
//                                 }}>
//                                     "{card.quote}"
//                                 </p>

//                                 <div style={{
//                                     borderTop: `1px solid ${theme.border}`,
//                                     paddingTop: '20px'
//                                 }}>
//                                     <h4 style={{
//                                         margin: '0 0 4px 0',
//                                         fontSize: '1.1rem',
//                                         fontWeight: '600',
//                                         color: theme.textMain
//                                     }}>
//                                         {card.author}
//                                     </h4>
//                                     <div style={{
//                                         display: 'flex',
//                                         gap: '8px',
//                                         fontSize: '0.8rem',
//                                         color: theme.textMuted
//                                     }}>
//                                         <span style={{ color: theme.accent, fontWeight: '500' }}>{card.project}</span>
//                                         <span>•</span>
//                                         <span>{card.location}</span>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     );
//                 })}
//             </div>

//             {/* ==================== MOBILE NAVIGATION DOTS ==================== */}
//             <div className="mobile-indicator-dots-row" style={{ display: 'none', justifyContent: 'center', gap: '8px', marginTop: '30px' }}>
//                 {feedbackList.map((dot) => (
//                     <div
//                         key={dot.id}
//                         style={{
//                             width: activeFeedbackId === dot.id ? '24px' : '8px',
//                             height: '8px',
//                             borderRadius: '4px',
//                             background: activeFeedbackId === dot.id ? theme.accent : 'rgba(44, 48, 46, 0.2)',
//                             transition: 'all 0.3s ease'
//                         }}
//                     />
//                 ))}
//             </div>

//             {/* ==================== CINEMATIC LIGHTBOX OVERLAY ==================== */}
//             {fullscreenVideo && (
//                 <div
//                     onClick={() => setFullscreenVideo(null)}
//                     style={{
//                         position: 'fixed',
//                         top: 0,
//                         left: 0,
//                         width: '100vw',
//                         height: '100vh',
//                         background: 'rgba(253, 252, 251, 0.98)',
//                         zIndex: 200,
//                         display: 'flex',
//                         justifyContent: 'center',
//                         alignItems: 'center',
//                         backdropFilter: 'blur(20px)'
//                     }}
//                 >
//                     <button
//                         onClick={() => setFullscreenVideo(null)}
//                         style={{ position: 'absolute', top: '30px', right: '40px', background: 'none', border: 'none', color: theme.textMain, fontSize: '2.5rem', cursor: 'pointer', opacity: 0.8 }}
//                     >
//                         ✕
//                     </button>
//                     <video
//                         autoPlay
//                         controls
//                         playsInline
//                         onClick={(e) => e.stopPropagation()}
//                         style={{ width: 'auto', height: '80vh', aspectRatio: '9/16', borderRadius: '24px', boxShadow: '0 30px 70px rgba(44, 48, 46, 0.15)', background: '#000' }}
//                     >
//                         <source src={fullscreenVideo} type="video/mp4" />
//                     </video>
//                 </div>
//             )}
//         </div>
//     );
// };

// export default ClientFeedbacks;


import React, { useState, useRef } from 'react';

import clientReviewVideo from '../Assets/slider/client2video.mp4';
import clientReviewPhoto from '../Assets/slider/clint1half.jpg';
import clientReviewPhoto3 from '../Assets/slider/client3.jpg';
import clientReviewvideo4 from '../Assets/slider/client4video.mp4';
import clientReviewvideo5 from '../Assets/Project5/Picture5.png';



const ClientFeedbacks = () => {
    const [fullscreenVideo, setFullscreenVideo] = useState(null);
    const videoRefs = useRef({});

    const feedbackList = [
        {
            id: 1,
            type: 'video',
            src: clientReviewVideo,
            quote: `We had a wonderful experience working with the Stinterior Studio. From the very first discussion to the final execution, they were extremely supportive, professional, and attentive to our needs. They took the time to understand our preferences, lifestyle, and budget, and translated them into a design that was both beautiful and practical. What really stood out was their attention to detail, transparent communication, and ability to solve challenges quickly during execution. The entire journey — from planning, design iterations, material selection, to on-site coordination — was smooth and well managed. \nThanks to their dedication and craftsmanship, our space has turned out exactly the way we envisioned (and even better). We truly appreciate their hard work and would highly recommend them to anyone looking for a reliable and creative interior design partner.`,
            author: "Sanket & Gauri Raut",
            project: "Songbirds Society",
            location: "Bhugaon, Pune",
            rating: "⭐⭐⭐⭐⭐"
        },
        {
            id: 2,
            type: 'photo',
            src: clientReviewPhoto,
            quote: `STInterior Studio was recommended to us by a close friend, and from our very first meeting, we knew we had made the right choice.\n\nThey brought fresh ideas and thoughtful solutions that perfectly matched our vision often suggesting better alternatives we hadn't even considered. Every discussion was handled with patience, professionalism, and genuine attention to detail, making the entire journey smooth and enjoyable.\n\nWe're truly delighted with the outcome and would happily recommend STInterior Studio to anyone looking for beautifully designed, thoughtfully crafted interiors.`,
            author: "Kalpesh Hiwase",
            project: "The Sage Apartment",
            location: "Kalyani Nagar, Pune",
            rating: "⭐⭐⭐⭐⭐"
        },
        {
            id: 5,
            type: 'photo',
            src: clientReviewvideo5,
            quote: `We explored every possible options for interior designer, and the online/offline reviews confused us even more. We accidentally bumped into stinterior studio through a distant contact. I had a few calls with Ar.Shreya and met her in-person .We took a leap of faith and signed up with Stinterior Studio .We had an amazing experience overall, some of the aspects that stood out are: 
-Innovative and meticulous design.
-Great attention to detail   Initial estimates where very much in line with the final expense 
-Transparency through the phases - expense & payments, progress reporting.
-End to end ownership during the execution phase by dealing with vendors and tracking the progress. 
They are a true professional and highly gifted designer. They have a unique ability to really listen and genuinely takes the time to understand you and your project. They are courteous, reliable and a real pleasure to work with. They are exceptionally accommodating with requests and are generous and intuitive always creating a feeling of complete ease and trust. Thank you both for a memorable experience and being part of this journey to build our office. Absolutely loved it. We recommend her highly. Go ahead with them without any second thought.`,
            author: "Mr.Rahul Rewenwar",
            project: "",
            location: "Kothrud, Pune",
            rating: "⭐⭐⭐⭐⭐"
        },
        {
            id: 3,
            type: 'photo',
            quote: `I had a wonderful experience working with Ar.Shreya (Stinterior Studio), right from the very first conversation I was very much impressed by the first conversation. She clearly explained the entire process and took the time to truly understand my vision—creating a my office that feels comfortable and elegant without being too gaudy. \n\nTheir creativity in design, excellent coordination, and ability to manage the entire project within the promised timelines really stood out. The team went above and beyond in helping me with selections,which made a huge difference in bringing everything together beautifully. I’m extremely happy with the outcome and would definitely recommend this team for their teamwork, creativity, thoughtful design approach.`,
            src: clientReviewPhoto3,
            author: "Gaurav Joshi",
            project: "Platinum 9",
            location: "Pashan-sus, Pune",
            rating: "⭐⭐⭐⭐⭐"
        },
        {
            id: 4,
            type: 'video',
            src: clientReviewvideo4,
            quote: `I got in touch with Ar.Shreya from Stinterior Studio to design our first home. Right on the first call,Ar.Shreya provided a lot of clarity on her work process and style. \n\nShe was able to understand our vision and managed to translate it beautifully. She is extremely patient, polite, a good listener and always puts her client's needs first. She is a perfectionist and a go getter and won't compromise on the quality of work. She also keeps a close watch on the budget and always presented us a with a variety of options for all our selections. She works with a lot of integrity, is very approachable and hands on. It was a great experience working with her and the team and I would highly recommend her!`,
            author: "Kedar Bendre",
            project: "The Entrance Portal",
            location: "Baner Hills, Pune",
            rating: "⭐⭐⭐⭐⭐"
        },
        {
            id: 6,
            type: 'text',
            author: "Mr& Mrs Mishra",
            quote: `AR.Shreya (Stinterior studio)is very professional and she has got great taste in implementation and design. She is extremely prompt and supportive. She delivered what we actually imagined for our house. You can blindly trust her in her choices. Highly recommended.`,
            project: "Casa Hoshi",
            location: "Wakad, Pune",
            rating: "⭐⭐⭐⭐⭐"
        },
        {
            id: 7,
            type: 'text',
            author: "Mr&Mrs Mahajan",
            quote: `Some people look for beautiful place, some make a place beautiful.\n\nWe are extremely happy with the work done by Ar. Shreya. What impressed us the most was her excellent communication. She patiently listened to our ideas and never forced her choices on us. Instead, she explained every option clearly and calmly, helping us make the right decisions.\n\nShe has a wonderful sense of color and used elegant, decent shades that give our home a warm and sophisticated look. Every corner of the house has been utilized thoughtfully and efficiently, making the space both beautiful and functional. The combination of wallpapers and wall colors is simply perfect and has enhanced the overall look of our home.\n\nHer professionalism, creativity, patience, and attention to detail made the entire journey smooth and enjoyable. We truly appreciate her dedication and highly recommend her to anyone looking for a talented and trustworthy interior designer.\n\nThank you for turning our dream home into a beautiful reality!`,
            project: "Casa Aki",
            location: "Magarpatta, Pune",
            rating: "⭐⭐⭐⭐⭐"
        },
        {
            id: 8,
            type: 'text',
            author: "Mr&Mrs Shinde",
            quote: `When we were looking for an Interior Designer for our newly purchased property, we had a very specific idea of what our home should "feel" like, so our search zeroed in on a select few in the Baner area. The process of finally choosing one came down to cost, timelines, and whether we felt the designer truly understood our taste and needs. With some designers, the very first meeting ended without any meaningful discussion, while others quoted unrealistically low prices just to win the project, which itself felt like a warning sign. It made us wonder whether any designer would genuinely take the time to understand our vision.

Then we came to know about Stinterior Studio. When I called Ar. Shreya and requested a meeting, my worries started to disappear. Here was a designer who visited our apartment for the very first time and immediately shared several thoughtful ideas while also taking the time to understand our taste and our family's requirements. Unlike others, who wouldn't even discuss concepts before receiving the first payment, Stinterior Studio was a refreshing and welcome find.

Needless to say, we decided to go ahead with Stinterior Studio for designing our home.

Today, we absolutely love our dream home and continue to receive compliments from everyone who visits.

Thanks to Ar. Shreya and her team! We highly recommend Stinterior Studio!`,
            project: "Casa Noa",
            location: "NIBM Road, Pune",
            rating: "⭐⭐⭐⭐⭐"
        },
        {
            id: 9,
            type: 'text',
            author: "Mr&Mrs Butle",
            quote: `Easy, fun, and spot-on design service!

When you meet someone as passionate as Ar. Shreya and her team, you immediately know that their heart is truly in their work.

We did extensive research before choosing an interior designer because we wanted someone who was understanding, collaborative, honest, flexible, and creative. We finally chose Stinterior Studio, and it turned out to be the perfect decision. They did an excellent job transforming the vision we had for our space into a beautiful reality.

We especially loved their process of understanding our requirements before proposing solutions. Their flexibility, responsiveness, involvement, agility, and exceptional talent and sense of design made the entire journey smooth and stress-free.

We are truly delighted with the outcome and highly recommend Ar. Shreya and the Stinterior Studio team to anyone looking for a professional and creative interior design partner.`,
            project: "Atelier Oderi",
            location: "Sinhagad Road, Pune",
            rating: "⭐⭐⭐⭐⭐"
        },
        {
            id: 10,
            type: 'text',
            author: "Ms. Rutvija",
            quote: `We are one of the happy customers who chose Stinterior Studio to design our home. Ar. Shreya and her team helped us turn our dream home into reality with the utmost perfection.

From the very beginning until the completion of the project, their professionalism and proactive approach were truly commendable. Ar. Shreya's excellent consultative skills helped us make the right decisions at every stage of the journey.

She paid attention to even the smallest details and ensured that every aspect of the design matched our expectations. Her creative approach, combined with a wide variety of design ideas and thoughtful suggestions, gave us the confidence that our home was in the right hands.

Thank you, Ar. Shreya and the Stinterior Studio team, for making our dream home a beautiful reality. We highly recommend Stinterior Studio to anyone looking for a professional, creative, and reliable interior design partner.`,
            project: "Casa Yura",
            location: "Shivajinagar, Pune",
            rating: "⭐⭐⭐⭐⭐"
        },
    ];

    const theme = {
        background: '#FDFCFB',
        surface: '#FFFFFF',
        accent: '#D4AF37',
        textMain: '#2C302E',
        textMuted: '#7A827E',
        border: 'rgba(44, 48, 46, 0.08)'
    };

    const handleVideoPlay = (id) => {
        if (videoRefs.current[id]) {
            videoRefs.current[id].play().catch(() => { });
        }
    };

    const handleVideoPause = (id) => {
        if (videoRefs.current[id]) {
            videoRefs.current[id].pause();
            videoRefs.current[id].currentTime = 0;
        }
    };

    const inlineStyles = `
    @import url('https://fonts.googleapis.com/css2?family=Cinzel:wght@400;500;600&display=swap');

    @keyframes revealUp {
        from { opacity: 0; transform: translateY(30px); }
        to { opacity: 1; transform: translateY(0); }
    }

    .team-animate-entry { 
        animation: revealUp 1s cubic-bezier(0.16, 1, 0.3, 1) forwards; 
    }

    .feedback-list-container {
        display: flex;
        flex-direction: column;
        gap: 40px;
        max-width: 1100px;
        margin: 0 auto;
    }

    .horizontal-feedback-card {
        display: flex;
        flex-direction: row;
        background: #FFFFFF;
        border: 1px solid rgba(44, 48, 46, 0.08);
        border-radius: 16px;
        overflow: hidden;
        transition: transform 0.4s ease, box-shadow 0.4s ease, border-color 0.4s ease;
        min-height: 380px;
    }

    .horizontal-feedback-card:hover {
        transform: translateY(-4px);
        box-shadow: 0 16px 36px rgba(44, 48, 46, 0.06);
        border-color: #D4AF37;
    }

    .horizontal-feedback-card.reverse-row {
        flex-direction: row-reverse;
    }

    .horizontal-media-wrapper {
        flex: 0 0 40%;
        min-width: 320px;
        position: relative;
        background: #F3F4F6;
        overflow: hidden;
    }

    .horizontal-content-wrapper {
        flex: 1;
        padding: 40px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        background: #FFFFFF;
    }

    .horizontal-card-media {
        width: 100%;
        height: 100%;
        object-fit: cover;
        transition: transform 0.6s cubic-bezier(0.16, 1, 0.3, 1);
    }

    .horizontal-feedback-card:hover .horizontal-card-media {
        transform: scale(1.03);
    }

    .reel-indicator {
        position: absolute;
        bottom: 16px;
        right: 16px;
        background: rgba(255, 255, 255, 0.9);
        color: #2C302E;
        padding: 6px 12px;
        border-radius: 20px;
        font-size: 0.7rem;
        font-weight: 700;
        letter-spacing: 1px;
        z-index: 5;
        box-shadow: 0 4px 10px rgba(0,0,0,0.05);
    }

    @media (max-width: 768px) {
        .feedback-screen-padding { padding: 40px 20px !important; }
        .feedback-main-title { font-size: 2rem !important; letter-spacing: 3px !important; }

        .horizontal-feedback-card,
        .horizontal-feedback-card.reverse-row {
            flex-direction: column !important;
        }

        .horizontal-media-wrapper {
            flex: none;
            width: 100%;
            height: 250px;
            min-width: unset;
        }

        .horizontal-content-wrapper {
            padding: 24px;
        }
    }
    `;

    return (
        <div className="feedback-screen-padding" style={{
            background: theme.background,
            minHeight: '100vh',
            color: theme.textMain,
            padding: '80px 40px',
            fontFamily: 'system-ui, -apple-system, sans-serif',
            boxSizing: 'border-box'
        }}>
            <style>{inlineStyles}</style>

            {/* Header */}
            <section className="team-animate-entry" style={{
                textAlign: 'center',
                marginBottom: '60px',
                padding: '0 20px'
            }}>
                <span style={{
                    fontFamily: 'system-ui, -apple-system, sans-serif',
                    fontSize: '0.85rem',
                    fontWeight: '600',
                    textTransform: 'uppercase',
                    letterSpacing: '4px',
                    color: theme.accent,
                    display: 'block',
                    marginBottom: '12px'
                }}>
                    Testimonials
                </span>
                <h1 className="feedback-main-title" style={{
                    fontFamily: "'Cinzel', serif",
                    fontSize: 'calc(0.3rem + 1.2vw)',
                    fontWeight: '400',
                    textTransform: 'uppercase',
                    letterSpacing: '6px',
                    color: theme.textMain,
                    margin: 0
                }}>
                    Turning Spaces Into Stories
                </h1>
                <div style={{
                    width: '60px',
                    height: '1px',
                    background: theme.accent,
                    margin: '24px auto 0 auto'
                }} />
            </section>

            {/* Alternating Side-by-Side Feedback List */}
            <div className="feedback-list-container">
                {feedbackList.map((card, idx) => {
                    const isVideo = card.type === 'video';
                    const hasMedia = card.type !== 'text' && card.src;
                    const isEven = idx % 2 === 1;

                    return (
                        <div
                            key={card.id}
                            className={`team-animate-entry horizontal-feedback-card ${isEven && hasMedia ? 'reverse-row' : ''}`}
                            onMouseEnter={() => isVideo && handleVideoPlay(card.id)}
                            onMouseLeave={() => isVideo && handleVideoPause(card.id)}
                            onClick={() => isVideo && setFullscreenVideo(card.src)}
                            style={{
                                animationDelay: `${idx * 0.1}s`,
                                cursor: isVideo ? 'pointer' : 'default'
                            }}
                        >
                            {/* Media Section (Video or Photo) */}
                            {hasMedia && (
                                <div className="horizontal-media-wrapper">
                                    {isVideo ? (
                                        <>
                                            <video
                                                ref={(el) => (videoRefs.current[card.id] = el)}
                                                className="horizontal-card-media"
                                                loop
                                                muted
                                                playsInline
                                            >
                                                <source src={card.src} type="video/mp4" />
                                            </video>
                                            <div className="reel-indicator">PLAY REEL</div>
                                        </>
                                    ) : (
                                        <img
                                            src={card.src}
                                            alt={card.project}
                                            className="horizontal-card-media"
                                        />
                                    )}
                                </div>
                            )}

                            {/* Content Section (Star Rating, Review, Author details) */}
                            <div className="horizontal-content-wrapper">
                                <div>
                                    {/* Star Rating */}
                                    <div style={{
                                        fontSize: '1rem',
                                        marginBottom: '16px',
                                        letterSpacing: '2px'
                                    }}>
                                        {card.rating || '⭐⭐⭐⭐⭐'}
                                    </div>

                                    {/* Quote */}
                                    <p style={{
                                        fontSize: '0.95rem',
                                        lineHeight: '1.75',
                                        fontWeight: '400',
                                        color: theme.textMain,
                                        fontStyle: 'italic',
                                        margin: '0 0 24px 0',
                                        whiteSpace: "pre-line"
                                    }}>
                                        "{card.quote}"
                                    </p>
                                </div>

                                {/* Author Info Footer */}
                                <div style={{
                                    borderTop: `1px solid ${theme.border}`,
                                    paddingTop: '20px',
                                    marginTop: '20px'
                                }}>
                                    <h4 style={{
                                        margin: '0 0 6px 0',
                                        fontSize: '1.1rem',
                                        fontWeight: '600',
                                        color: theme.textMain,
                                        fontFamily: "'Cinzel', serif",
                                    }}>
                                        {card.author}
                                    </h4>
                                    <div style={{
                                        display: 'flex',
                                        flexWrap: 'wrap',
                                        alignItems: 'center',
                                        gap: '8px',
                                        fontSize: '0.85rem',
                                        color: theme.textMuted
                                    }}>
                                        <span style={{ color: theme.accent, fontWeight: '500' }}>{card.project}</span>
                                        <span>•</span>
                                        <span> {card.location}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>

            {/* Lightbox Video Modal */}
            {fullscreenVideo && (
                <div
                    onClick={() => setFullscreenVideo(null)}
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100vw',
                        height: '100vh',
                        background: 'rgba(253, 252, 251, 0.98)',
                        zIndex: 200,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        backdropFilter: 'blur(20px)'
                    }}
                >
                    <button
                        onClick={() => setFullscreenVideo(null)}
                        style={{
                            position: 'absolute',
                            top: '30px',
                            right: '40px',
                            background: 'none',
                            border: 'none',
                            color: theme.textMain,
                            fontSize: '2.5rem',
                            cursor: 'pointer',
                            opacity: 0.8
                        }}
                    >
                        ✕
                    </button>
                    <video
                        autoPlay
                        controls
                        playsInline
                        onClick={(e) => e.stopPropagation()}
                        style={{
                            width: 'auto',
                            height: '80vh',
                            aspectRatio: '9/16',
                            borderRadius: '24px',
                            boxShadow: '0 30px 70px rgba(44, 48, 46, 0.15)',
                            background: '#000'
                        }}
                    >
                        <source src={fullscreenVideo} type="video/mp4" />
                    </video>
                </div>
            )}
        </div>
    );
};

export default ClientFeedbacks;